import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=ecdccb18&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=ecdccb18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdccb18",
  null
  
)

export default component.exports